import { useId, useRef } from "react";
import { SectionTitle } from "@sprout/typography.tsx";
import { MultiCheckbox } from "@sprout/checkbox.tsx";

import { SpecializedMultiSelectFilterProps } from "@components/job_search/filters/multi_select_filter.tsx";
import { Drawer, DrawerContent, DrawerTrigger } from "@components/ui/drawer.tsx";
import ArrowDownIcon from "@sprout/icons/arrow_down.tsx";
import { SecondaryButton } from "@sprout/buttons";

export const MobileMultiSelectFilter = ({
  buttonText,
  name,
  onSelect,
  options,
  values,
}: SpecializedMultiSelectFilterProps) => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const id = useId();

  return (
    <Drawer onClose={() => triggerRef.current?.blur()}>
      <DrawerTrigger asChild>
        <SecondaryButton ref={triggerRef} size="medium">
          <div className="flex items-center justify-center gap-1 w-full">
            {buttonText}
            <ArrowDownIcon size="sm" color="green" />
          </div>
        </SecondaryButton>
      </DrawerTrigger>
      <DrawerContent className="gap-2" onCloseAutoFocus={(e) => e.preventDefault()}>
        <SectionTitle>{name}</SectionTitle>
        <div className="text-[24px]/[1.5] text-dark-green">
          <MultiCheckbox
            id={id}
            options={options}
            isMulti={true}
            onSelect={onSelect}
            values={values}
            size="lg"
            spacing={2}
          />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
